import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { CardComponent } from 'src/app/shared/ui-kit/card/card.component';

import { HealthMetadataComponentAbstract } from '../../metadata-components/health-metadata/health-metadata.component.abstract';

@Component({
  selector: 'app-health-metadata-v2',
  standalone: true,
  imports: [CommonModule, CardComponent],
  templateUrl: './health-metadata-v2.component.html',
})
export class HealthMetadataV2Component extends HealthMetadataComponentAbstract {}
